import { __rest } from '../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Button } from '../Components/ui/button.js';
import { cn } from '../lib/utils.js';

const suggestionsContainerStyle = {
    width: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
};
const suggestionsInnerStyle = {
    display: 'flex',
    width: 'max-content',
    minWidth: 0,
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: '8px',
};
const suggestionsInnerStyleTruncated = {
    display: 'flex',
    width: '100%',
    minWidth: 0,
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: '8px',
};
const Suggestions = (_a) => {
    var { className, children, style } = _a, props = __rest(_a, ["className", "children", "style"]);
    const shouldTruncate = (style === null || style === void 0 ? void 0 : style.overflowX) === 'hidden' || (style === null || style === void 0 ? void 0 : style.overflowX) === 'clip';
    const innerStyle = shouldTruncate ? suggestionsInnerStyleTruncated : suggestionsInnerStyle;
    return (React__default.createElement("div", Object.assign({ className: cn('suggestions-scroll', className), style: Object.assign(Object.assign({}, suggestionsContainerStyle), style) }, props),
        React__default.createElement("div", { style: innerStyle }, children)));
};
const getPaddingForSize = (size) => {
    if (!size || size === 'sm' || size === 'icon') {
        return { padding: '8px' };
    }
    if (size === 'default') {
        return { paddingLeft: '12px', paddingRight: '12px', paddingTop: '8px', paddingBottom: '8px' };
    }
    if (size === 'lg') {
        return { padding: '12px' };
    }
    return { paddingLeft: '12px', paddingRight: '12px', paddingTop: '8px', paddingBottom: '8px' };
};
const getBaseButtonStyle = (isSelected) => (Object.assign({ cursor: 'pointer', borderRadius: '9999px', height: 'auto', fontSize: '14px', fontWeight: 500, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', whiteSpace: 'nowrap', overflow: 'hidden', minWidth: 0, flexShrink: 0, flexBasis: 'auto', width: 'fit-content', transition: 'background-color 0.2s' }, (isSelected
    ? {}
    : {
        border: '1px solid #333333',
        backgroundColor: '#FFFFFF',
        color: '#000000',
    })));
const Suggestion = (_a) => {
    var { suggestion, onClick, className, variant = 'outline', size = 'default', children, style, selected = false } = _a, props = __rest(_a, ["suggestion", "onClick", "className", "variant", "size", "children", "style", "selected"]);
    const handleClick = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick(suggestion);
    };
    const paddingStyle = getPaddingForSize(size);
    const isSelected = selected;
    const dynamicStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, getBaseButtonStyle(isSelected)), paddingStyle), (isSelected
        ? {
            // Only set border to ensure it exists, color will come from CSS
            border: '1px solid transparent',
        }
        : {})), style);
    return (React__default.createElement(Button, Object.assign({ className: cn('suggestion-btn tw:font-medium tw:cursor-pointer tw:rounded-full tw:overflow-hidden tw:min-w-0 tw:flex-shrink tw:max-w-full', isSelected && 'suggestion-btn-selected tw:bg-primary tw:text-primary-foreground tw:border-primary', !isSelected && 'tw:bg-white tw:text-primary tw:border-[#333333]', className), onClick: handleClick, size: size, type: "button", variant: variant, style: dynamicStyle }, props),
        React__default.createElement("span", { style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
                minWidth: 0,
                maxWidth: '100%',
                lineHeight: '22px',
            } }, children || suggestion)));
};

export { Suggestion, Suggestions };
//# sourceMappingURL=suggestion.js.map
